import React from 'react';
import { Receipt } from 'lucide-react';

export default function ReceiptsPanel({ receipts }) {
  return (
    <div className="panel rounded-3xl p-6">
      <h3 className="font-display text-2xl text-cream mb-1 flex items-center gap-2"><Receipt size={20} className="text-gold" /> Receipts</h3>
      {receipts.length ? (
        <div className="mt-4 space-y-2">
          {receipts.map((p) => (
            <div key={p.code} className="rounded-xl border hairline p-4 flex items-center justify-between">
              <div><p className="text-sm text-cream">{p.item}</p><p className="text-xs text-cream/45">{p.code} &middot; {p.date}</p></div>
              <span className="font-display text-xl text-cream">${p.amount}</span>
            </div>
          ))}
        </div>
      ) : <p className="text-sm text-cream/55 mt-2">Your receipts show up here after you buy a song.</p>}
    </div>
  );
}
